<template>
  <EventList 
    :sortedKeys="sortedKeys"
    :sortedCalendario="sortedCalendario"
    :aulascolor="eventColors" />
</template>

<script>
import { computed } from "vue";
import EventList from "@/components/avaliacaolist/eventList.vue";
import { useHorarios } from "@/stores/horarios.ts";

let weekdayFormatter = null;
let dayFormatter = null;
let monthFormatter = null;

export default {
  props:["week"],
  inject:["lang"],
  components:{
    EventList
  },
  setup(){
    const horarios = useHorarios();
    const eventColors = computed(()=>horarios.aulascolor);
    const aulas = computed(()=>horarios.aulas);

    return {
      eventColors,
      aulas
    }
  },
  computed:{
    sortedKeys() {
      return this.aulas
        .map(item => {
          if(item["Data"] != null){
            return this.getFormatedKey(new Date(item.Data));
          }
        })
        .filter((value, index, self) => self.indexOf(value) === index && value != null);
    },
    sortedCalendario(){
      this.aulas.sort((a, b) => {
        let dateComparison = new Date(a.Data) - new Date(b.Data);
        if(dateComparison === 0) {
          return a.horaInicio.localeCompare(b.horaInicio);
        } else {
          return dateComparison;
        }
      });
      const evts = this.aulas.reduce((accumulator, current) => {
        let formattedDate
        if(current["Data"] != null){
          formattedDate = this.getFormatedKey(new Date(current['Data']));
          (accumulator[formattedDate] = accumulator[formattedDate] || []).push(current);
        }
        return accumulator;
      },{});
      return evts;
    },
  },
  created(){
    const idioma = this.lang == "pt" ? "pt-PT" : "en-uk" ;
    weekdayFormatter = new Intl.DateTimeFormat(idioma, { weekday: 'long' });
    dayFormatter = new Intl.DateTimeFormat(idioma, { day: '2-digit' });
    monthFormatter = new Intl.DateTimeFormat(idioma, { month: 'long' });
  },
  methods:{
    getFormatedKey(date){
      return `${dayFormatter.format(date)} ${monthFormatter.format(date)} - ${weekdayFormatter.format(date)}`;
    }
  }
}
</script>